import resume from '../assets/pdf/Sai_Teja_Bhoomraogari_Resume.pdf'
import cv from '../assets/pdf/Sai_Teja_Bhoomraogari_CV.pdf'
import display_pic from '../assets/header/saiteja_bhoomraogari.png'

export const headerData = {
    name: 'Sai Teja Bhoomraogari',
    firstName: 'Sai Teja',
    lastName: 'Bhoomraogari',
    title: 'Software Engineer, Cloud Infrastructure and Backend Systems',
    description: 'Building automation frameworks, pipelines, and cloud infrastructure at enterprise scale. Currently at SAIF Corporation. Previously Amazon.',
    image: display_pic,
    resumePdf: resume,
    cvPdf: cv
}
